(function(){
'use strict';
if(window.NoveraliI18nCompleteReady)return;
window.NoveraliI18nCompleteReady=(async function(){
  var parts=window.NoveraliI18nCompleteChunks||[];
  if(parts.length<4||parts.some(function(part){return !part;}))throw new Error('Incomplete translation payload');
  if(typeof DecompressionStream!=='function')throw new Error('Gzip decompression is not supported by this browser');
  var encoded=parts.join(''),binary=atob(encoded),bytes=new Uint8Array(binary.length);
  for(var i=0;i<binary.length;i++)bytes[i]=binary.charCodeAt(i);
  var stream=new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
  var text=await new Response(stream).text(),payload=JSON.parse(text);
  var d=window.NoveraliI18nData=window.NoveraliI18nData||{sources:[],packs:{},away:{}};
  d.sources.push.apply(d.sources,payload.sources||[]);
  Object.keys(payload.packs||{}).forEach(function(locale){
    d.packs[locale]=d.packs[locale]||[];
    d.packs[locale].push.apply(d.packs[locale],payload.packs[locale]);
  });
  window.NoveraliI18nCompleteChunks=null;
  return true;
})().catch(function(error){
  console.warn('[Noverali i18n] Complete translation payload could not be loaded:',error);
  return false;
});
})();